module.exports = __webpack_public_path__ + "static/img/Decor_04.386b644.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/desktop@1x/pic/Decor_04.png
// module id = kYvg
// module chunks = 0